import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type InboxGetLinkParams = {
  page: 'inbox';
  accountId: string;
  settingsSection?: 'profile';
};

export const getLinkForInbox = (params: InboxGetLinkParams): ValidHref => {
  if (params.settingsSection) {
    return createUrl({
      pathname: `/inbox/${params.accountId}/settings/${params.settingsSection}`,
    });
  }

  return createUrl({
    pathname: `/inbox/${params.accountId}`,
  });
};

export const isInboxPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  if (parts[1] === 'inbox') {
    return true;
  }

  return false;
};
